import booker from './booker'
import addOn from './addOn'
import promotion from './promotion'

export default {
   'en-us': Object.assign({}, booker, addOn, promotion),
}
